"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidElement = void 0;
/**
 * Checks whether a value is an element.
 *
 * @param value - The `value` you want to check. It can be any a value of any type.
 * @returns - Returns `true` if the `value` is an element. Otherwise, it returns `false`.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isValidElement(value) {
    if (!value || typeof value !== 'object') {
        // eslint-disable-next-line no-console
        console.warn("Invalid JSX element. Expected an object but got: ".concat(value));
        return false;
    }
    if (typeof value.type !== 'function') {
        // eslint-disable-next-line no-console
        console.warn("Invalid JSX type. Expected a class or function but got: ".concat(value.type));
        return false;
    }
    return true;
}
exports.isValidElement = isValidElement;
//# sourceMappingURL=valid.js.map